import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import React from "react";
import { v4 as uuid } from "uuid";
import { slugify } from "../../../utils/stringUtils";
import { AnchorContainer } from "../AnchorContainer";
import { Property, PropertyProps } from "./Property";

const Properties: React.FC<{ properties: PropertyProps[]; heading?: string }> = ({
    properties,
    heading = "Properties:"
}) => {
    if (!properties.length) {
        return null;
    }
    return (
        <AnchorContainer paddingBottom="space60" id={slugify(heading)}>
            <Heading as="h3" variant="heading30">
                {heading}
            </Heading>
            <Box as="ul" listStyleType="none" marginBottom="space60" padding="space0">
                {properties.map((property: PropertyProps) => (
                    <Property key={uuid()} isRootProp {...property} />
                ))}
            </Box>
        </AnchorContainer>
    );
};

export { Properties };
